<template>
  <div class="wrapper">
    <div class="page-header header-filter" :style="headerStyle">
      <div class="container">
        <div class="md-layout">
          <div class="md-layout-item md-size-100 text-center">
            <h1 class="title">500</h1>
            <h2 class="description">Внутренняя ошибка системы :(</h2>
            <h4 class="description">Ooooups! Что-то пошло не так.</h4>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  bodyClass: "error-page",
  data() {
    return {
      image: require("@/assets/img/clint-mckoy.jpg"),
      headerStyle : {},
    };
  }
};
</script>

<style lang="scss">
</style>
